import { match } from 'path-to-regexp'

export type DashIdRouteParam = {
    dashId: string
}

const DashIdPathSlug = '/dashboards/:dashId'

export const getDashId = (maybeDashId?: string): string | undefined => {
    if (maybeDashId) {
        return maybeDashId
    }

    // Modal may not exist on React-Router tree
    const matchRes = match<DashIdRouteParam>(DashIdPathSlug)(window.location.pathname)

    if (!matchRes) {
        return undefined
    }

    return matchRes.params.dashId
}
